var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ButtonPrimary, ButtonSecondary, ButtonTertiary } from "../Button/";
import { Buttongroup, ButtongroupAction } from '../Buttongroup/';
import { Dropdown } from '../Dropdown/';
import "./NavAction.scss";

var templates = {
    "primary": ButtonPrimary,
    "secondary": ButtonSecondary,
    "tertiary": ButtonTertiary
};

var NavAction = (_temp2 = _class = function (_Component) {
    _inherits(NavAction, _Component);

    function NavAction() {
        var _temp, _this, _ret;

        _classCallCheck(this, NavAction);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            expandIndex: false
        }, _this.onToggle = function (index) {

            var expandIndex = void 0;

            if (_this.state.expandIndex === index) {
                expandIndex = false;
            } else {
                expandIndex = index;
            }

            _this.setState({
                expandIndex: expandIndex
            });

            /*
             this.setState(prevState => ({
                expanded: !prevState.expanded
                expandedIndex: !prevState.expanded
            }));
            */
        }, _this.renderButton = function (button, index) {
            var _this$props = _this.props,
                buttonType = _this$props.buttonType,
                align = _this$props.align;
            var title = button.title,
                url = button.url,
                onClick = button.onClick,
                children = button.children;
            var expandIndex = _this.state.expandIndex;


            var expanded = void 0;

            if (expandIndex === index) {
                expanded = true;
            } else {
                expanded = false;
            }

            //        const { expanded } = this.state;

            var ButtonTemplate = void 0;

            if (templates[buttonType]) {
                ButtonTemplate = templates[buttonType];
            } else {
                ButtonTemplate = ButtonPrimary;
            }

            if (url && children || onClick && children) {
                return React.createElement(
                    Buttongroup,
                    { key: index },
                    React.createElement(ButtonTemplate, _extends({}, button, { expanded: expanded, onToggle: function onToggle() {
                            return _this.onToggle(index);
                        } })),
                    React.createElement(
                        Dropdown,
                        { type: 'action', expanded: expanded, align: align },
                        React.createElement(ButtongroupAction, _extends({}, _this.props, { buttongroup: children }))
                    )
                );
            }

            if (children) {
                return React.createElement(
                    Buttongroup,
                    { key: index },
                    React.createElement(ButtonTemplate, _extends({}, button, { children: false, expanded: expanded, onToggle: function onToggle() {
                            return _this.onToggle(index);
                        } })),
                    React.createElement(
                        Dropdown,
                        { type: 'action', expanded: expanded, align: align },
                        React.createElement(ButtongroupAction, _extends({}, _this.props, { buttongroup: children }))
                    )
                );
            }

            return React.createElement(
                Buttongroup,
                { key: index },
                React.createElement(ButtonTemplate, _extends({}, button, { label: title }))
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    NavAction.prototype.render = function render() {
        var _props = this.props,
            buttongroup = _props.buttongroup,
            button = _props.button;


        if (!buttongroup && button) {
            buttongroup = [button];
        }

        if (!buttongroup) {
            return false;
        }

        return React.createElement(
            'nav',
            { className: 'nav-action' },
            buttongroup.map(this.renderButton)
        );

        /*
         const { title, url, onClick, children } = button;
        
        let ButtonTemplate;
        
        if (templates[buttonType]) {
            ButtonTemplate = templates[buttonType]
        } else {
            ButtonTemplate = ButtonPrimary;
        }
         if (url && children || onClick && children) {
            return (
                <nav className="nav-action">
                    <ButtonTemplate {...button} expanded={expanded} onToggle={this.onToggle} />
                    <Dropdown type="action" expanded={expanded} align={align} onClick={this.onToggle}>
                        <ButtongroupAction {...this.props} buttongroup={children} />
                    </Dropdown>
                </nav>
            )
        }
         if (children) {
            return (
                <nav className="nav-action">
                    <ButtonTemplate {...button} children={false} expanded={expanded} onToggle={this.onToggle} />
                    <Dropdown type="action" expanded={expanded} align={align}>
                        <ButtongroupAction {...this.props} buttongroup={children} />
                    </Dropdown>
                </nav>
            )
        }
         return (
            <nav className="nav-action">
                <ButtonTemplate {...button} label={title} />
            </nav>
        )
        
        */
    };

    return NavAction;
}(Component), _class.defaultProps = {
    align: "left",
    buttonType: "primary",
    buttongroup: undefined
}, _temp2);
NavAction.propTypes = process.env.NODE_ENV !== "production" ? {} : {};
NavAction.propTypes = process.env.NODE_ENV !== "production" ? {
    /** Align */
    align: PropTypes.string,
    /** Button type */
    buttonType: PropTypes.string,
    /** Buttongroup */
    buttongroup: PropTypes.array,
    /** Button */
    button: PropTypes.object
} : {};


export default NavAction;